// PHP opens `window._msAuthBroadcastChannel` in every page it serves, with a
// listener that sends any page but `/auth` to `/auth?action=sign-out` when a
// "signout" message comes in. The sign-out screen lives at `/auth/sign-out`
// and loads `/signout.php` in an iframe, which always broadcasts "signout":
// the screen would be sent back to itself forever. The auth app is where a
// sign-out ends, so it swaps that channel for one without the PHP listener;
// it still posts on it and still hears the other tabs' "signin".
export function detachPlatformSignoutListener(): void {
  const platformChannel = window._msAuthBroadcastChannel;
  if (!platformChannel) {
    return;
  }
  platformChannel.close();
  window._msAuthBroadcastChannel = new BroadcastChannel("mobsuccess.auth");
}
